// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/media.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Struct, Timestamp } from "@bufbuild/protobuf";
import { PageRequest, PageResponse } from "./common_pb.js";

/**
 * @generated from message omnios.v1.Media
 */
export const Media = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.Media",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "urn", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "mime_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "size_bytes", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "thumbnail_urn", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "width", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "height", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "attrs", kind: "message", T: Struct },
    { no: 11, name: "variants", kind: "message", T: MediaVariant, repeated: true },
    { no: 12, name: "media_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "duration", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 14, name: "bitrate", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 15, name: "framerate", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 16, name: "codec", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.MediaVariant
 */
export const MediaVariant = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.MediaVariant",
  () => [
    { no: 1, name: "urn", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "width", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "height", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "format", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "size_bytes", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "duration", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "bitrate", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "framerate", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "codec", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.UploadMediaRequest
 */
export const UploadMediaRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UploadMediaRequest",
  () => [
    { no: 1, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "mime_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 4, name: "entity_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "entity_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetMediaRequest
 */
export const GetMediaRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetMediaRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.BatchGetMediaRequest
 */
export const BatchGetMediaRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BatchGetMediaRequest",
  () => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.BatchGetMediaResponse
 */
export const BatchGetMediaResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BatchGetMediaResponse",
  () => [
    { no: 1, name: "media", kind: "message", T: Media, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ListMediaRequest
 */
export const ListMediaRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListMediaRequest",
  () => [
    { no: 1, name: "entity_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "entity_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "page", kind: "message", T: PageRequest },
  ],
);

/**
 * @generated from message omnios.v1.ListMediaResponse
 */
export const ListMediaResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListMediaResponse",
  () => [
    { no: 1, name: "media", kind: "message", T: Media, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.DeleteMediaRequest
 */
export const DeleteMediaRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteMediaRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetMediaUrlRequest
 */
export const GetMediaUrlRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetMediaUrlRequest",
  () => [
    { no: 1, name: "media_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "variant_format", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "variant_width", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "ttl_seconds", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.GetMediaUrlResponse
 */
export const GetMediaUrlResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetMediaUrlResponse",
  () => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "expires_at_unix", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message omnios.v1.BatchGetMediaUrlsRequest
 */
export const BatchGetMediaUrlsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BatchGetMediaUrlsRequest",
  () => [
    { no: 1, name: "media_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "variant_format", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "variant_width", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "ttl_seconds", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.MediaUrlEntry
 */
export const MediaUrlEntry = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.MediaUrlEntry",
  () => [
    { no: 1, name: "media_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "expires_at_unix", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message omnios.v1.BatchGetMediaUrlsResponse
 */
export const BatchGetMediaUrlsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BatchGetMediaUrlsResponse",
  () => [
    { no: 1, name: "urls", kind: "message", T: MediaUrlEntry, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.CopyToCdnRequest
 */
export const CopyToCdnRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CopyToCdnRequest",
  () => [
    { no: 1, name: "media_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.CopyToCdnResponse
 */
export const CopyToCdnResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CopyToCdnResponse",
  () => [
    { no: 1, name: "copied", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "skipped", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "errors", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

